import { IresDevice } from "./IresDevice";

import { ProgramChain } from "./ProgramChain";

import { isNewDryRunProgramChain } from "@/data/models/ProgramChain";
import { doesProgramChainStartBeforeCurrentProjectAssignmentStartDate } from "@/data/models/PanelAssignment";

export interface LatestIresDeviceInfo {
  iresDevice: IresDevice;
  mostRecentProgramChain?: ProgramChain;
}

export function isCurrentAssignmentMissingProgramChain(
  latestIresDeviceInfo: LatestIresDeviceInfo
) {
  const { iresDevice, mostRecentProgramChain } = latestIresDeviceInfo;

  if (!mostRecentProgramChain) {
    return false;
  }

  const isProgramChainAlreadyAssigned = !!mostRecentProgramChain.assignedProjectId;

  return (
    isProgramChainAlreadyAssigned ||
    isNewDryRunProgramChain(mostRecentProgramChain) ||
    doesProgramChainStartBeforeCurrentProjectAssignmentStartDate(
      iresDevice,
      mostRecentProgramChain
    )
  );
}
